import { Gantt as GanttDhtmlx } from '../../../assets/gantt/dhtmlxgantt';

/**
 * This function get new instance from dhtmlx lib, and updates it sector date format config, as also set options for checkbox
 * @param {*} sector Sector object which is actually used
 * @returns Returns an DHTMLX gantt lib object
 */
const getNewGanttLibInstance = (sector, calendars, t) => {
  const newGantt = GanttDhtmlx.getGanttInstance({
    config: {
      work_time: true,
      duration_unit: 'hour',
      duration_step: 1,
      time_step: 60,
      date_format: '%Y-%m-%d %H:%i',
      hoursPerDay: 8
    }
  });
  newGantt.criteriaStatusOptions = ['Baseline', 'Follow'];
  newGantt.status_criteria = 'Baseline';
  newGantt.dateFormatOptions = [
    'DD/MM/YY',
    'MM/DD/YY',
    'DD/MM/YYYY',
    'MM/DD/YYYY',
    'DD/MM/YY hh:mm',
    'MM/DD/YY hh:mm'
  ];
  newGantt.hashMoment2Date = {
    'DD/MM/YY': '%d/%m/%y',
    'MM/DD/YY': '%m/%d/%y',
    'DD/MM/YYYY': '%d/%m/%Y',
    'MM/DD/YYYY': '%m/%d/%Y',
    'DD/MM/YY hh:mm': '%d/%m/%y %H:%i',
    'MM/DD/YY hh:mm': '%m/%d/%y %H:%i'
  };
  newGantt.currentDateFormat =
    sector.dateFormat || (t('lang') === 'en' ? 'MM/DD/YY' : 'DD/MM/YY');
  newGantt.deletedUnsavedActivities = [];
  newGantt.deletedUnsavedLinks = [];
  newGantt.shouldAdjustWorkingHours = true;

  return newGantt;
};
export { getNewGanttLibInstance };
